<template>
  <dialog-base
    v-bind="$props"
    :key="renderKey"
    :header="t('account.dialogs.myAccountDialog.headers.myAccount')"
    :loading-message="t('account.dialogs.myAccountDialog.messages.updatingAccountInformation')"
    @close="close"
    @confirm="$refs.myAccountForm.submit()">
    <template #activator="slotProps" v-if="!externalActivator">
      <!--
        @slot Custom activator for the dialog
        @binding {object} slotProps Object containing {on, attrs}
      -->
      <slot v-if="$slots.activator" name="activator" v-bind="slotProps"></slot>
      <primary-button
        v-else
        before-icon="account"
        v-on="slotProps.on"
        v-bind="slotProps.attrs"
        large
        class="mr-2">
        {{ t('account.dialogs.myAccountDialog.buttons.myAccount') }}
      </primary-button>
    </template>
    <template #body>
      <my-account-form @close="close" @saved="handleSaved" ref="myAccountForm"></my-account-form>
    </template>
  </dialog-base>
</template>

<script>
import dialogMixin from '@satellite/components/mixins/dialogMixin';
import { t } from '@nova/core';

/**
 * Button/Dialog for my Account form
 * @displayName My Account Dialog
 */
export default {
  name: 'my-account-dialog',
  mixins: [dialogMixin],
  methods: {
    t,
    handleSaved(data) {
      this.$emit('saved', data);
      this.$eventHub.$emit('update-User', data);
    }
  }
};
</script>
